import { Component } from "@angular/core";
import { provideTranslationScope, TranslatePipe } from "@app/shared/i18n/translation-scope";
import { scope } from "./i18n/scope";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { MenuSystemDirective } from "@app/shared/directives/menu-system.directive";
import { TpaConnectionOverviewComponent } from "./third-party-assurance/overview/tpa-overview.component";

@Component({
    selector: "app-external-connection-overview",
    templateUrl: "./external-connection-overview.component.html",
    styleUrls: ["./external-connection-overview.component.scss"],
    imports: [MenuSystemDirective, TranslatePipe, TpaConnectionOverviewComponent],
    viewProviders: [provideTranslationScope(scope)],
})
export class ExternalConnectionOverviewComponent {
    tabID: string;
    tab: TabModel;

    constructor() {}
}
